// Module
var code = `<template class="font-selector">
  <require from="./font-selector.scss"></require>
  <select value.bind="value">
    <option>Roboto</option>
    <option repeat.for="f of fonts" model.bind="f.value">\${f.label}</option>
  </select>
</template>
`;
// Exports
export default code;